import type { CallHistory, DigitalConsoleType } from "../consts/ozonetel/sdk";

export async function getCallRecordingData(sdk: DigitalConsoleType) {
  try {
    const agentHistory = await sdk.getAgentCallHistory?.();
    const callHistory = JSON.parse(agentHistory?.callHist ?? '[]') as CallHistory[];
    return callHistory;
  } catch (e) {
    console.error(`Could not parse JSON: ${(e as { message?: string }).message}`);
    return [];
  }
}
